import type { DemoScenario } from "@/hooks/useMockupFallback";

/** Demo scenario 안내 배너 표시 전용 컴포넌트. */
interface DemoScenarioBannerProps {
  isScenarioActive: boolean;
  scenario: DemoScenario;
}

export default function DemoScenarioBanner({
  isScenarioActive,
  scenario,
}: DemoScenarioBannerProps) {
  if (!isScenarioActive) return null;

  return (
    <div
      data-testid="scenario-banner"
      className="mb-4 p-3 rounded-lg border border-amber-300 bg-amber-50 text-amber-900 text-sm flex items-start gap-2"
    >
      <span aria-hidden="true">📌</span>
      <span>
        <strong>시나리오 예시</strong> — 모델 결과 해석 방식을 설명하기 위한
        데모 데이터입니다 (
        {scenario === "arson-strong"
          ? "인화성 패턴 유사도 높음 시나리오"
          : "인화성 패턴 유사도 낮음 시나리오"}
        , RoMSH 확률 점수 시뮬레이션). 실제 분석값은 URL에서{" "}
        <code className="bg-amber-100 px-1 rounded">?scenario=</code> 쿼리를
        제거하면 확인할 수 있습니다.
      </span>
    </div>
  );
}
